import React from 'react';
import { Modal, message, Button, Popconfirm, Icon } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import InvRemark from './InvRemark';
import format from '../../shared/format';

class MoreRemark extends React.Component {
    state = {
        visible: false,
        loading: false,
        investigationId: '',
    }

    show = investigationId => {
        this.setState({
            visible: true,
            investigationId,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    remarkDelete = (investigationId, investigationFinishRemarkId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.deleteInvestigationFinishRemark,
            data: {
                investigationId,
                investigationFinishRemarkId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    showInvRemark = () => {
        const { investigationId } = this.state;
        this.invRemarkRef.show(investigationId);
    }

    render() {
        const { list, type } = this.props;
        const { visible, loading, investigationId } = this.state;
        const { curRole } = sessionStorage;
        const isShow = curRole === 'BO' || curRole === 'PM';
        let array = list;
        if (type === 'pro') {
            const option = list.find(i => i.investigationId == investigationId) || {};
            array = option.investigationFinishRemarks || [];
        }
        return (
            <div>
                <Modal
                    title="项目完工百分比备注"
                    visible={visible}
                    onCancel={this.hide}
                    className="create-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="800px"
                    loading={loading}
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
                >
                    {
                        isShow &&
                        <div style={{ textAlign: "right", marginBottom: "15px" }}>
                            <Button type="primary" onClick={this.showInvRemark}>添加备注</Button>
                        </div>
                    }
                    {
                        array.length ?
                            <div>
                                {
                                    array.map((d, index) =>
                                        <div key={d.investigationFinishRemarkId} style={(array.length != (index + 1)) ? { borderBottom: "2px dashed #d6d4d4" } : null}>
                                            <p style={{ textAlign: 'left', paddingTop: 10 }}>{format('joint', d.userName, d.modifyTime, 'roundBrackets')}
                                                {
                                                    (isShow && d.type !== 'INV_TIME_UPDATE') &&
                                                    <span>
                                                        <Popconfirm title='确认要删除吗?' onConfirm={() => this.remarkDelete(investigationId, d.investigationFinishRemarkId)} okText="确定" cancelText="取消">
                                                            <Icon type="close"
                                                                style={{ color: "red", position: "relative", top: 3, float: "right", cursor: "pointer" }}
                                                            />
                                                        </Popconfirm>
                                                    </span>
                                                }
                                            </p>
                                            <p style={{ textAlign: 'left', paddingBottom: 10, width: "756px", whiteSpace: "initial" }}>{d.remark}</p>
                                        </div>
                                    )
                                }
                            </div>
                        :
                            null
                    }
                </Modal>
                <InvRemark ref={el => this.invRemarkRef = el} loadData={this.props.loadData} />
            </div>
        );
    }
}

export default MoreRemark;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/MoreRemark.js